<template>
  <div>
    <v-btn color="primary" @click="dialog_ativo = ! dialog_ativo">
      <v-icon left>mdi-plus</v-icon>
      novo
    </v-btn>

    <v-dialog v-model="dialog_ativo" content-class="bra-20" width="600" transition="dialog-top-transition">
      <v-card>
        <v-card-title class="py-5">
          <span>Importação arquivo</span>

          <v-spacer />

          <v-btn icon @click="dialog_ativo = ! dialog_ativo">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pl-6 pr-4 py-0">
          <div class="mt-n1">
            <BaixarModeloArquivo />

            <table id="tabela-formato-arquivo" class="mt-1">
              <tr>
                <td>"id_produto";</td>
                <td>"nome_produto";</td>
                <td>"classificacao"</td>
              </tr>
              <tr v-for="(curva, index) in ['X', 'Y', 'Z']" :key="index">
                <td>{{ `${index + 1}`.padStart(6, '0') }};</td>
                <td>Descrição do produto {{ `${index + 1}`.padStart(6, '0') }};</td>
                <td v-text="curva" />
              </tr>
            </table>
          </div>

          <div class="mt-5 font-13">
            <p class="ma-0">
              <span class="font-weight-medium">id_produto:</span>
              Obrigatório
            </p>
            <p class="ma-0">
              <span class="font-weight-medium">nome_produto:</span>
              Opcional
            </p>
            <p class="ma-0">
              <span class="font-weight-medium">classificacao:</span>
              Obrigatório
            </p>
          </div>

          <v-file-input
            label="Selecione o arquivo*"
            v-model="arquivo"
            outlined
            show-size
            class="mt-5"
            prepend-icon=""
            accept=".csv"
            :error-messages="arquivoErros"
          />
        </v-card-text>

        <div class="d-flex px-4 pb-3">
          <v-spacer />
          <v-btn text color="primary" @click="importarArquivo">salvar</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {required} from "vuelidate/lib/validators";
import {importarArquivoCurvasCriticidade} from "@/api/Parametrizacao/CurvaCriticidade";
import BaixarModeloArquivo from "@/components/Parametrizacao/CurvasCriticidade/BaixarModeloArquivo";

export default {
  name: "DialogImportacao",
  components: {
    BaixarModeloArquivo
  },
  data: () => ({
    dialog_ativo: false,
    arquivo: null,
    mensagem_erro: null
  }),
  validations: {
    arquivo: {
      required,
      extencao: function () {
        if (!this.arquivo) return false;
        return this.arquivo.name.toLowerCase().startsWith('.csv', (this.arquivo.name.length - 4));
      },
      erro: function () {
        return this.mensagem_erro === null;
      }
    }
  },
  computed: {
    arquivoErros() {
      const errors = [];
      if (!this.$v.arquivo.$dirty) return errors;
      !this.$v.arquivo.required && errors.push("Campo Obrigatório.");
      !this.$v.arquivo.extencao && errors.push("O arquivo deve ser de extenção csv.");
      !this.$v.arquivo.erro && errors.push(this.mensagem_erro);
      return errors;
    }
  },
  watch: {
    dialog_ativo() {
      if (!this.dialog_ativo) {
        this.arquivo = null;
        this.$v.$reset();
      }
    },
    arquivo() {
      this.$v.$reset();
    }
  },
  methods: {
    importarArquivo() {
      this.$v.$touch();
      this.mensagem_erro = null;

      if (this.$v.$invalid) return;

      const callback_sucesso = () => {
        this.dialog_ativo = false;
        this.$emit('importacao-com-sucesso', {})
      }

      const callback_erro = ({ response }) => {
        localStorage.token = response.data.token;
        this.mensagem_erro = response.data.menssagem_erro;
      }

      this.$store.dispatch(
        'loading/addRequisicao',
        importarArquivoCurvasCriticidade(this.arquivo).then(callback_sucesso).catch(callback_erro)
      );
    },
  }
}
</script>

<style scoped>
#tabela-formato-arquivo {
  border-collapse: collapse;
  font-size: 13px;
}
#tabela-formato-arquivo tr td {
  border: 1px solid #e5e5e5;
  padding: 0 5px;
}
</style>
